export default "__VITE_ASSET__BV3O9bLJ__"